import { axios } from '@/utils/request'

/**
 * 查询列表
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function pictureQuery (parameter) {
  return axios({
    url: '/baCarousel/getAllCarousel',
    method: 'get',
    params: parameter
  })
}

/**
 * 修改轮播图
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function pictureEdit (parameter) {
  return axios({
    url: '/baCarousel/updateCarousel',
    method: 'post',
    data: parameter
  })
}

/**
 * 添加问诊订单管理
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function pictureAdd (parameter) {
  return axios({
    url: '/baCarousel/insertCarousel',
    method: 'post',
    data: parameter
  })
}


/**
 * 删除
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function pictureDelete (parameter) {
  return axios({
    url: '/baCarousel/updateCarousel',
    method: 'post',
    data: parameter
  })
}


/**
 * 发布
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function pictureRelease (parameter) {
  return axios({
    url: '/baCarousel/publishCarousel',
    method: 'get',
    params: parameter
  })
}




/**
 * 上传图片
 *
 * @author LIWEI
 * @date 2022-04-07 16:19:42
 */
export function pictureUpdate (parameter) {
  return axios({
    url: '/baCarousel/cos/upload',
    method: 'post',
    data: parameter
  })
}
